import { render, staticRenderFns } from "./ProvisionalAppointment.vue?vue&type=template&id=56d536f9&scoped=true&"
import script from "./ProvisionalAppointment.vue?vue&type=script&lang=js&"
export * from "./ProvisionalAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionalAppointment.vue?vue&type=style&index=0&id=56d536f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d536f9",
  null
  
)

export default component.exports